import {IListViewField} from "src/components/Shared/ILIstViewField";
import { AppEntities } from "src/config/entities";
import {IListViewCreateDependedDocumentAction} from "src/components/Shared/IListViewCreateDependedDocumentAction";
import {IListViewOptions} from "src/components/Shared/NewDocumentListView";
import {ListView} from "src/components/Shared/ListViews/ListView";
import {DocumentListViewToolbar} from "src/components/Shared/ListViews/DocumentListViewToolbar";
import {
    DocumentListViewDefaultToolbarButtons
} from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import {ListviewToolbarSubmenuButton} from "src/components/Shared/ListViews/ListviewToolbarSubmenuButton";
import {ListviewToolbarMoreActions} from "src/components/Shared/ListViews/ListviewToolbarMoreActions";

const PurchaseOrdersList = () => {
    const fields: IListViewField[] = [
        {
            fieldName: "id",
            title: "Id",
            fieldType: "string",
        },
        {
            fieldName: "companyName",
            title: "Company",
            fieldType: "string",
        },
        {
            fieldName: "vendorName",
            title: "Vendor",
            fieldType: "string",
        },
        {
            fieldName: "totalAmount",
            title: "Total Amount",
            fieldType: "number",
            format: {
                type: "fixedPoint",
                precision: 2,
            },
        },
    ];

    const createVendorInvoices = async (data: { id: string }) => {
        const dataService = AppEntities.VendorInvoices.getDataService();
        return await dataService.createBasedAtOrder(data.id);
    };

    const createDocumentActions: IListViewCreateDependedDocumentAction[] = [
        {
            title: "Vendor Invoices",
            appEntity: AppEntities.VendorInvoices,
            createBaseAtFunction: createVendorInvoices,
        },
    ];
    const listViewOptions: IListViewOptions = {
        paginationEnabled: true,
    };

    return (
        <>
            <ListView
                createDocumentActions={createDocumentActions}
                fields={fields}
                entity={AppEntities.PurchaseOrders}
                createDependedDocumentActions={createDocumentActions}
                createMoreActions={[]}
            >
                <DocumentListViewToolbar>
                    <DocumentListViewDefaultToolbarButtons>
                        <ListviewToolbarSubmenuButton/>
                    </DocumentListViewDefaultToolbarButtons>
                    <ListviewToolbarMoreActions/>
                </DocumentListViewToolbar>
            </ListView>
        </>
    );
};

export default PurchaseOrdersList;
